import { Link } from "react-router-dom";
import { Megaphone, Star, Newspaper, Share2, Calendar, Store } from "lucide-react";
import { Button } from "@/components/ui/button";

const OPPS = [
  { icon: Star, t: "Featured Barber Spots", d: "Top placement in city and category pages so the right clients find you first.", price: "Featured Pro" },
  { icon: Store, t: "Featured Shop Drops", d: "Weekly shop features that showcase your team, openings, and offers.", price: "Shop / add-on" },
  { icon: Newspaper, t: "Sponsored Articles", d: "Interviews, product launches, and brand stories written and promoted by Barbistry.", price: "Custom" },
  { icon: Share2, t: "Social Promo Packages", d: "Reels, spotlights, and repost eligibility across Barbistry channels.", price: "Add-on" },
  { icon: Calendar, t: "Homepage & City Features", d: "Premium placement in front of high-intent visitors.", price: "Custom" },
  { icon: Megaphone, t: "Launch Campaigns", d: "Coordinated media pushes for product drops and brand launches.", price: "Custom" },
];

export default function Advertising() {
  return (
    <div>
      <section className="border-b border-white/10 bg-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24">
          <p className="font-mono text-xs uppercase tracking-widest text-[#D4AF37] mb-4">Advertising & Featured Opportunities</p>
          <h1 className="font-display text-4xl md:text-6xl font-bold max-w-3xl">Buy visibility where it converts.</h1>
          <p className="mt-6 text-neutral-300 max-w-2xl">Featured placement, sponsored content, and social promotion — built to put shops, barbers, and vendors in front of the right audience.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {OPPS.map((o) => (
            <div key={o.t} className="bg-[#111] border border-white/10 p-7 hover:-translate-y-1 hover:border-[#D4AF37]/40 transition-transform duration-300">
              <o.icon className="text-[#D4AF37]" size={26} />
              <h3 className="mt-5 font-display text-xl font-semibold">{o.t}</h3>
              <p className="mt-2 text-sm text-neutral-400 leading-relaxed">{o.d}</p>
              <span className="mt-5 inline-block font-mono text-xs uppercase tracking-wider text-[#D4AF37] border border-[#D4AF37]/40 px-2 py-1">{o.price}</span>
            </div>
          ))}
        </div>

        <div className="mt-16 border border-white/10 bg-[#0a0a0a] p-8 md:p-12">
          <h2 className="font-display text-2xl md:text-3xl font-bold">Performance campaigns</h2>
          <p className="mt-4 text-neutral-300 max-w-3xl">
            Standard memberships don't include revenue-share claims on your outside growth. But if Barbistry runs a custom growth campaign — media feature, social push, or sponsored launch — a separate agreement can define revenue share, referral fees, or performance bonuses. Fair, clear, and only for premium promotional partnerships.
          </p>
          <div className="mt-7 flex flex-wrap gap-4">
            <Link to="/register"><Button className="rounded-none bg-[#D4AF37] text-black hover:bg-[#F0C84B] font-semibold" data-testid="adv-get-started">Start a Campaign</Button></Link>
            <Link to="/policy/advertising"><Button variant="outline" className="rounded-none border-white/25 bg-transparent text-white hover:border-[#D4AF37] hover:text-[#D4AF37]" data-testid="adv-terms">Read Promotion Terms</Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
